module.exports = __webpack_public_path__ + "static/media/130.7760f789.jpg";